 export const ModuleConstant = {
	Module: {
		SmartSafety: 1,
		Vision: 2,
	}
}

